import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    // 1. FEATURED - Nosto's AI-powered recommendation engine (DEFAULT)
    createSortOption("featured", "Relevance", { field: "_score", order: "desc" }),
    
    // 2. BEST SELLERS - Most clicked/converts best
    createSortOption("bestselling", "Most Popular", { field: "stats.revenue", order: "desc" }),
    
    // 3. CUSTOMER RATINGS - High engagement, builds trust
    // createSortOption("-rating", "Top Rated", { field: "rating", order: "desc" }),
    
    // 4. NEWEST - Creates urgency and FOMO
    createSortOption("-date_published", "Newest", { 
        field: "datePublished", 
        order: "desc" 
    }),
    
    // 5. PRICE LOW TO HIGH - Most used price filter
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    
    // 6. PRICE HIGH TO LOW - For luxury/premium positioning
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
]

// COLLECTION PERFORMANCE INSIGHTS:
// 
// HIGH CLICK COLLECTIONS (in order of effectiveness):
// 1. "Sale" - Price-driven traffic, highest click rates
// 2. "New Arrivals" - FOMO + curiosity drive engagement  
// 3. "Best Sellers" - Social proof increases confidence
// 4. "Trending Now" - Combines social proof + urgency
// 5. "Customer Favorites" - Review-based social proof
//
// SEASONAL WINNERS:
// - "Gift Guide" (Q4: 300%+ higher clicks)
// - "Holiday Collection" (Seasonal relevance)
// - "Summer Essentials" / "Winter Must-Haves" (timing)
//
// AOV BOOSTERS:
// - "Bundle Deals" - Higher average order value
// - "Complete the Look" - Cross-sell opportunity
// - "Frequently Bought Together" - Personalized upsells
//
// PERSONALIZATION TIP: Rotate collections based on:
// - User behavior (returning vs new)
// - Season/holidays
// - Inventory levels
// - Performance metrics

export const defaultConfig = {
    sort: sortOptions[0], // Default to Best Selling - highest conversion
    serpSize: sizes[0],
    autocompleteProductsSize: 3,
    autocompleteKeywordsSize: 4,
    historySize: 5
}

export const suggestedCollections = [
    {
        title: 'Sale',
        url: '/collections/sale',
        image: null
    },
    {
        title: 'New Arrivals',
        url: '/collections/new',
        image: null
    },
    {
        title: 'Best Sellers',
        url: '/collections/best-sellers',
        image: null
    },
    {
        title: 'Pants',
        url: '/collections/pants',
        image: null
    },
    // {
    //     title: 'Customer Favorites',
    //     url: '/collections/top-rated',
    //     image: null
    // }
]